import { useMemo } from "react";
import * as React from "react";
import { StyleSheet } from "react-native";

import { FormikStaticTextField, useTheme } from "@smartrent/ui";

import { useFormikFieldsHook } from "@/pages/hub-refurbish/hooks/useFormikFieldsHook";
import {
  HubRefurbishFormikFieldLabels,
  HubRefurbishFormikFieldNames,
  HubRefurbishReactQueryKeys,
} from "@/types/HubRefurbishProps";

import { ConnectionStatus } from "@/utils/zipato";

import { useHubRefurbishContext } from "@/pages/hub-refurbish/HubRefurbishContext";

interface FormikRedisStatsOfflineFieldProps {
  required?: boolean;
}

export const RedisStatsFormikFieldOffline: React.FC<
  React.PropsWithChildren<FormikRedisStatsOfflineFieldProps>
> = ({ required }) => {
  const { colors } = useTheme();
  const { getHubs } = useHubRefurbishContext();

  const offlineHubs = useMemo(
    () => getHubs((hub) => hub?.status === ConnectionStatus.Offline),
    [getHubs]
  );

  // OFFLINE
  const { onClearCallback, containerStyle, labelStyle, disabled } =
    useFormikFieldsHook({
      required,
      name: HubRefurbishFormikFieldNames.Offline,
      queryKey: HubRefurbishReactQueryKeys.RedisStats,
      value: offlineHubs,
    });

  return (
    <FormikStaticTextField
      style={styles.root}
      containerStyle={{
        ...containerStyle,
        ...{ backgroundColor: colors.errorMutedBackground },
      }}
      labelStyle={{
        ...labelStyle,
        ...{ color: colors.errorText },
      }}
      name={HubRefurbishFormikFieldNames.Offline}
      label={HubRefurbishFormikFieldLabels.Offline}
      onPress={() => null}
      transformValue={(value) => value?.length} // display count only
      onClear={onClearCallback}
      disabled={disabled}
    />
  );
};

const styles = StyleSheet.create({
  root: { maxWidth: 175 },
});
